import LiveLinkDialog from '../QueryAdder/LiveLinkDialog';
import { TrackerDataType } from '../../shared/constants/constants';

type LiveLinkData = {
  type?: string;
  name?: string;
  description?: string;
  path?: string;
  [key: string]: unknown;
};

type EditCollapsedLiveLinkDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly liveLinkData?: LiveLinkData | null;
  readonly onSaveItem: (item: LiveLinkData) => void;
  readonly onDeleteItem: () => void;
};

export default function EditCollapsedLiveLinkDialog({
  open,
  onClose: _onClose,
  liveLinkData,
  onSaveItem,
  onDeleteItem,
}: EditCollapsedLiveLinkDialogProps) {
  return (
    <LiveLinkDialog
      open={open}
      setOpen={(nextOpen) => {
        if (!nextOpen) {
          _onClose();
        }
      }}
      initialValue={liveLinkData}
      onSubmit={(value) =>
        onSaveItem({
          ...liveLinkData,
          ...value,
        })
      }
      onDelete={onDeleteItem}
      type={TrackerDataType.CONTENT_LOG}
    />
  );
}
